import { render, staticRenderFns } from "./resourceForm.vue?vue&type=template&id=6deea40f"
import script from "./resourceForm.vue?vue&type=script&lang=js"
export * from "./resourceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports